import { SET_PAGE_NUMBER, SET_ROWS_PER_PAGE } from "../utils/constants/redux";

export const setPageNumber = (pageNumber) => ({
  type: SET_PAGE_NUMBER,
  payload: pageNumber,
});

export const setRowsPerPage = (rowsPerPage) => ({
  type: SET_ROWS_PER_PAGE,
  payload: rowsPerPage,
});
